import { render } from "./AlertContactForm.vue?vue&type=template&id=45696cd5"
import script from "./AlertContactForm.vue?vue&type=script&lang=js"
export * from "./AlertContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__